module.exports = __webpack_public_path__ + "img/barrier.57eca9e7.jpg";